import { defineStore } from "pinia";
import { ref } from "vue";

export const useTokenStore = defineStore("token", () => {
    const token = ref<string>();

    function clear() {
        token.value = undefined;
    }

    function inject(newToken: string) {
        token.value = newToken;
    }

    function isValid() {
        return token.value !== undefined;
    }

    return { token, clear, inject, isValid };
});
